import React from "react"

const AddressIcon = ({ style }) => (
  <svg viewBox="0 0 20 20" fill="currentColor" style={style}>
    <path d="M17 7.3c0 3.1-1.6 5.5-3.3 7.6-.9 1.1-3.1 4-3.1 4l-.6.9-.7-.9s-2.2-2.9-3.1-4C4.6 12.8 3 10.4 3 7.3 3 3.4 6.2.2 10 .2s7 3.2 7 7.1zm-1.6-.1c0-3-2.4-5.4-5.4-5.4S4.6 4.3 4.6 7.2c0 2.4 1.1 4.2 2.9 6.6.6.8 1.7 2.2 2.4 3.2.7-1 1.9-2.4 2.4-3.2 2-2.3 3.1-4.2 3.1-6.6zm-3.2-.6c0 1.2-1 2.2-2.2 2.2s-2.2-1-2.2-2.2 1-2.2 2.2-2.2 2.2.9 2.2 2.2z" />
  </svg>
)

export default AddressIcon



// WEBPACK FOOTER //
// ./src/AtomicComponents/Icons/AddressIcon.jsx